import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IIpConfig, EmptyIpConfig } from "./EmptyIpConfig";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IIpConfig
}

export const IpConfig = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyIpConfig, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyIpConfig, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table  permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}
